/** @jsx jsx **/
import { jsx } from "@emotion/react";
import { useContext, useState } from "react";

import { Icon } from "@myrealtrip/design-system";

import { siteMapList } from "@constants";
import { DetermineMobileContext } from "@modules";

import * as styles from "./sitemap.style";

type listOpenType = [boolean, boolean, boolean];

export default function SiteMap() {
  const isMobile = useContext(DetermineMobileContext);
  const [listOpen, setListOpen] = useState<listOpenType>([false, false, false]);

  const handleClickListName = (index: number) => {
    const nextListOpen: listOpenType = [...listOpen];
    nextListOpen[index] = !listOpen[index];
    setListOpen(nextListOpen);
  };

  return (
    <ul css={styles.listUl}>
      {siteMapList.map((list, listIndex) => (
        <li css={styles.listLi} key={list.listName + listIndex}>
          <div
            css={styles.listNameBox}
            onClick={() => handleClickListName(listIndex)}
          >
            <span css={styles.listName}>{list.listName}</span>
            {isMobile && (
              <Icon
                css={styles.icon(listOpen[listIndex])}
                name="ic_arrowdown_sm_gray_300"
              />
            )}
          </div>
          {(!isMobile || listOpen[listIndex]) && (
            <ul>
              {list.list.map((item, itemIndex) => (
                <li key={item.itemName + itemIndex}>
                  <a css={styles.itemName} href={item.link}>
                    {item.itemName}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
}
